// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ga-a";
export var fulfillmentFormRail = "_ga-9";
export var headerTitleRow = "_ga-c";
export var orderDetailsWrapper = "_ga-7";
export var orderLinkTrigger = "_ga-2";
export var paymentInformationGrid = "_ga-h";
export var paymentSummaryColumn = "_ga-i";
export var shipmentContainer = "_ga-b";
export var shipmentDetailsMainPane = "_ga-8";
export var shipmentNavigationCard = "_ga-5";
export var shipmentNavigationRail = "_ga-3";
export var shipmentNavigationRailHeader = "_ga-4";
export var shipmentSummaryFact = "_ga-e";
export var shipmentSummaryGrid = "_ga-d";
export var shipmentSummaryMetadataRow = "_ga-f";
export var shipmentSummaryTags = "_ga-g";
export var shipmentWorkspace = "_ga-0";
export var shipmentWorkspaceContent = "_ga-6";
export var shipmentWorkspaceHeader = "_ga-1";